import React, { useState } from 'react';

function GiveawayForm({ giveaway, onClose, onSubmit }) {
  const [formData, setFormData] = useState({
    discorduser: '',
    age: '',
    contact: '',
    email: '',
    otherContact: '',
    why: '',
    activity: '',
    community: '',
    referral: ''
  });
  const [status, setStatus] = useState({ type: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus({ type: '', message: '' });

    // Validation
    if (!formData.discorduser || !formData.age || !formData.contact || 
        !formData.why || !formData.activity || !formData.community) {
      setStatus({ type: 'error', message: 'Please fill in all required fields.' });
      setIsSubmitting(false);
      return;
    }

    if (formData.contact === 'email' && !formData.email) {
      setStatus({ type: 'error', message: 'Please provide your email address.' });
      setIsSubmitting(false);
      return;
    }

    if (formData.contact === 'other' && !formData.otherContact) {
      setStatus({ type: 'error', message: 'Please provide your contact information.' });
      setIsSubmitting(false);
      return;
    }

    try {
      onSubmit(formData);
      setStatus({ type: 'success', message: '✅ Entry submitted successfully! Good luck!' });
      setTimeout(() => {
        onClose();
        setFormData({
          discorduser: '',
          age: '',
          contact: '',
          email: '',
          otherContact: '',
          why: '',
          activity: '',
          community: '',
          referral: ''
        });
        setStatus({ type: '', message: '' });
      }, 2000);
    } catch (error) {
      setStatus({ type: 'error', message: 'Error submitting entry. Please try again.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Enter: {giveaway.title}</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="discorduser">
              Discord Username <span style={{ color: '#ff4d6d' }}>*</span>
            </label>
            <input
              type="text"
              id="discorduser"
              name="discorduser"
              value={formData.discorduser}
              onChange={handleChange}
              placeholder="e.g. yourname#1234"
              required
              maxLength="37"
            />
          </div>

          <div className="form-group">
            <label htmlFor="age">
              Your Age <span style={{ color: '#ff4d6d' }}>*</span>
            </label>
            <input
              type="number"
              id="age"
              name="age"
              value={formData.age}
              onChange={handleChange}
              placeholder="e.g. 17"
              required
              min="13"
              max="99"
            />
          </div>

          <div className="form-group">
            <label htmlFor="contact">
              Contact Method <span style={{ color: '#ff4d6d' }}>*</span>
            </label>
            <select
              id="contact"
              name="contact"
              value={formData.contact}
              onChange={handleChange}
              required
            >
              <option value="">Select...</option>
              <option value="discord">Discord DM</option>
              <option value="email">Email</option>
              <option value="other">Other</option>
            </select>
          </div>

          {formData.contact === 'email' && (
            <div className="form-group">
              <label htmlFor="email">
                Email Address <span style={{ color: '#ff4d6d' }}>*</span>
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="e.g. you@email.com"
                required
              />
            </div>
          )}

          {formData.contact === 'other' && (
            <div className="form-group">
              <label htmlFor="otherContact">
                Other Contact <span style={{ color: '#ff4d6d' }}>*</span>
              </label>
              <input
                type="text"
                id="otherContact"
                name="otherContact"
                value={formData.otherContact}
                onChange={handleChange}
                placeholder="e.g. Telegram @youruser"
                required
                maxLength="40"
              />
            </div>
          )}

          <div className="form-group">
            <label htmlFor="why">
              Why should you win / What does Nitro mean for you? <span style={{ color: '#ff4d6d' }}>*</span>
            </label>
            <textarea
              id="why"
              name="why"
              value={formData.why}
              onChange={handleChange}
              placeholder="Short story or reasons why you'd love to win"
              required
              maxLength="300"
              rows="4"
            />
          </div>

          <div className="form-group">
            <label htmlFor="activity">
              How active are you on Discord? <span style={{ color: '#ff4d6d' }}>*</span>
            </label>
            <select
              id="activity"
              name="activity"
              value={formData.activity}
              onChange={handleChange}
              required
            >
              <option value="">Select...</option>
              <option value="all-day">All day / Always</option>
              <option value="daily">Daily</option>
              <option value="2-3x-week">2–3 times a week</option>
              <option value="rarely">Rarely</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="community">
              Are you a NitroDrop Discord member? <span style={{ color: '#ff4d6d' }}>*</span>
            </label>
            <select
              id="community"
              name="community"
              value={formData.community}
              onChange={handleChange}
              required
            >
              <option value="">Select...</option>
              <option value="yes">Yes, I'm in</option>
              <option value="no">Not yet, but will join</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="referral">How did you find us?</label>
            <input
              type="text"
              id="referral"
              name="referral"
              value={formData.referral}
              onChange={handleChange}
              placeholder="e.g. Friend, Reddit, Twitter"
              maxLength="40"
            />
          </div>

          {status.message && (
            <div className={`status-message ${status.type}`}>
              {status.message}
            </div>
          )}

          <button type="submit" className="submit-btn" disabled={isSubmitting}>
            {isSubmitting ? 'Submitting...' : 'Enter Giveaway'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default GiveawayForm;

